<template>
  <div class="home">
    <contents />
  </div>
</template>

<script>
import contents from './components/contents'
export default {
  name: 'index',
  components: {
    contents
  },
  data () {
    return {
    }
  },
  created () {
  }
}
</script>

<style lang="less" scoped>

</style>
